import {useCallback, useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {
    Accordion,
    AccordionDetails,
    AccordionTitle,
    CopyText,
    DataWrapper,
} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {SipTwilioSettings} from 'types';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SESSION.SIP.TWILIO_WEBHOOKS;
const COMMON_T_KEYS = TRANSLATION_KEYS.COMMON;

type Props = {
    loading: boolean;
    initialValues: SipTwilioSettings;
};

export const TwilioWebhooks: React.FC<Props> = ({
    loading, initialValues
}) => {
    const {t} = useTranslation();

    const domain = useMemo(() => location.origin, []);
    const getWebhookUrl = useCallback((suffix: string) =>
        `${domain}/api/twilio/${suffix}?token=${initialValues?.token}`, [domain, initialValues?.token]);

    const renderUrl = useCallback((suffix: string, query = '') => (
        <div className='tw-ml-6 tw-flex tw-items-center'>
            {t(COMMON_T_KEYS.ALL.HTTP_METHOD_POST)}
            <CopyText text={`${getWebhookUrl(suffix)}${query}`} labelPlacement='left' className='tw-ml-1 tw-break-all' />
        </div>
    ), [getWebhookUrl, t]);

    return (
        <DataWrapper isLoading={loading} hideContentOnLoading={false}>
            <Accordion className='tw-my-2'>
                <AccordionTitle>
                    <div className='tw-flex tw-justify-between tw-ts-h5-bold'>
                        {t(T_KEYS.TITLE)}
                    </div>
                </AccordionTitle>
                <AccordionDetails>
                    <div>
                        <div className='tw-ts-h5 tw-ml-2 tw-mt-4'>{t(T_KEYS.SIP_DOMAIN.TITLE)}</div>
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.SIP_DOMAIN.INCOME)}</div>
                        {renderUrl('sip-domain/calls/income')}
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.SIP_DOMAIN.STATUS)}</div>
                        {renderUrl('sip-domain/calls/status')}

                        <div className='tw-ts-h5 tw-ml-2 tw-mt-4'>{t(T_KEYS.APPLICATION.TITLE)}</div>
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.APPLICATION.INCOME)}</div>
                        {renderUrl('application/calls/income')}
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.APPLICATION.STATUS)}</div>
                        {renderUrl('application/calls/status')}
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.APPLICATION.INCOME_REDIRECT)}</div>
                        {renderUrl('application/calls/income', '&flow=redirect')}
                        <div className='tw-ts-base-bold tw-ml-4 tw-mt-2 tw-mb-1'>{t(T_KEYS.APPLICATION.INCOME_REDIRECT_RETURN)}</div>
                        {renderUrl('application/calls/income', '&flow=redirect-return')}
                    </div>
                </AccordionDetails>
            </Accordion>
        </DataWrapper>
    );
};